type Props = {
  children: React.ReactElement;
  condition: boolean;
  wrapper: (children: React.ReactElement) => React.JSX.Element;
};

const ConditionalWrapper: React.FC<Props> = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;

export default ConditionalWrapper;
